import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-[#FAFAFA] text-neutral-900 selection:bg-[#C5A059]/20 selection:text-neutral-900">
        <Header />

        <main className="flex-grow">
          <Routes>
            {/* Main routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/ydelser" element={<ServicesPage />} />

            {/* Individual dedicated Service pages */}
            <Route
              path="/ydelser/energioptimering"
              element={<ServiceDetailPage serviceSlugProp="energioptimering" />}
            />
            <Route
              path="/ydelser/varmepumper"
              element={<ServiceDetailPage serviceSlugProp="varmepumper" />}
            />
            <Route
              path="/ydelser/groen-udvikling"
              element={<ServiceDetailPage serviceSlugProp="groen-udvikling" />}
            />
            <Route
              path="/ydelser/gron-udvikling"
              element={<ServiceDetailPage serviceSlugProp="groen-udvikling" />}
            />
            <Route
              path="/ydelser/butikskoel"
              element={<ServiceDetailPage serviceSlugProp="butikskoel" />}
            />
            <Route
              path="/ydelser/butikskol"
              element={<ServiceDetailPage serviceSlugProp="butikskoel" />}
            />
            <Route
              path="/ydelser/industrikoel"
              element={<ServiceDetailPage serviceSlugProp="industrikoel" />}
            />
            <Route
              path="/ydelser/industrikol"
              element={<ServiceDetailPage serviceSlugProp="industrikoel" />}
            />
            <Route
              path="/ydelser/comfortkoel"
              element={<ServiceDetailPage serviceSlugProp="comfortkoel" />}
            />
            <Route
              path="/ydelser/comfortkol"
              element={<ServiceDetailPage serviceSlugProp="comfortkoel" />}
            />
            <Route
              path="/ydelser/koelemarked-convenience"
              element={<ServiceDetailPage serviceSlugProp="koelemarked-convenience" />}
            />
            <Route
              path="/ydelser/kolemarked-convenience"
              element={<ServiceDetailPage serviceSlugProp="koelemarked-convenience" />}
            />

            {/* Dynamic slug route fallback */}
            <Route path="/ydelser/:slug" element={<ServiceDetailPage />} />

            {/* Other routes */}
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />

            {/* Status pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </>
  );
}
